import { useNavigate, useParams } from 'react-router';
import { Header } from 'components/common/header/Header';
import { InvitationResultContent } from 'components/invitation/InvitationResultContent';
import './InvitationResult.css';

export const InvitationResult = () => {
    const navigate = useNavigate();
    const { inviteCode } = useParams();

    const meetingData = {
        meetingName: '맛집 탐방',
        hostName: '김위즈',
        date: '2024. 12. 10 (화)',
        time: '오후 6:00',
        location: '홍대입구역 9번 출구',
        participants: 5
    };

    const handleGoToMeeting = () => {
        navigate(`/meeting/detail/${inviteCode}`);
    };

    const handleGoToHome = () => {
        navigate('/home');
    };

    const handleGoToLocation = () => {
        navigate(`/meeting/location/${inviteCode}`);
    };

    return (
        <div className="invitation-result-wrapper">
            <Header title="참여 완료" isSubPage />

            <div className="invitation-result-content">
                <InvitationResultContent
                    meetingData={meetingData}
                    onGoToMeeting={handleGoToMeeting}
                    onGoToHome={handleGoToHome}
                    onGoToLocation={handleGoToLocation}
                />
            </div>

            <div className="invitation-result-footer">
                <button className="home-button" onClick={handleGoToHome}>
                    홈으로 이동
                </button>
            </div>
        </div>
    );
};
